import { render } from "./patientDoctorAccess.vue?vue&type=template&id=38ae03a0&lang=true"
import script from "./patientDoctorAccess.vue?vue&type=script&lang=js"
export * from "./patientDoctorAccess.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__